// TODO@static-determinant
const constructionPositionDefault = 'Благоустройство'

export const toConstructionPosition = x => x || constructionPositionDefault

export const fromConstructionPosition = x => x === constructionPositionDefault ? null : x
